<div class="row mrgn-bttm-lg">
    <div class="col-md-12">
        <div>
        <h3 class="text-center" [innerHtml]="termsAndConditions.title"></h3>
        <p [innerHtml]="termsAndConditions.terms.paragraph1"></p>
        <p [innerHtml]="termsAndConditions.terms.paragraph2"></p>
        <p [innerHtml]="termsAndConditions.terms.paragraph3"></p>
        <h5>
            <u>{{ termsAndConditions.terms.terms_title1 }}</u>
        </h5>
        <ul>
          <li [innerHtml]="termsAndConditions.terms.terms_title1_item1"></li>
          <li [innerHtml]="termsAndConditions.terms.terms_title1_item2"></li>
          <li [innerHtml]="termsAndConditions.terms.terms_title1_item3"></li>
          <li [innerHtml]="termsAndConditions.terms.terms_title1_item4"></li>
        </ul>
        <h5>
            <u>{{ termsAndConditions.terms.terms_title2 }}</u>
        </h5>
        <ul>
          <li [innerHtml]="termsAndConditions.terms.terms_title2_item1"></li>
          <ul>
            <li [innerHtml]="termsAndConditions.terms.terms_title2_item1_1"></li>
            <li [innerHtml]="termsAndConditions.terms.terms_title2_item1_2"></li>
            <li [innerHtml]="termsAndConditions.terms.terms_title2_item1_3"></li>
          </ul>
        </ul>
        <h5>
            <u>{{ termsAndConditions.terms.terms_title3 }}</u>
        </h5>
        <ul>
          <li [innerHtml]="termsAndConditions.terms.terms_title3_item1"></li>
          <li [innerHtml]="termsAndConditions.terms.terms_title3_item2"></li>
          <li [innerHtml]="termsAndConditions.terms.terms_title3_item3"></li>
        </ul>
        <h5>
            <u>{{ termsAndConditions.terms.terms_title4 }}</u>
        </h5>
        <ul>
          <li [innerHtml]="termsAndConditions.terms.terms_title4_item1"></li>
          <ul>
            <li [innerHtml]="termsAndConditions.terms.terms_title4_item1_1"></li>
            <li [innerHtml]="termsAndConditions.terms.terms_title4_item1_2"></li>
            <li [innerHtml]="termsAndConditions.terms.terms_title4_item1_3"></li>
            <li [innerHtml]="termsAndConditions.terms.terms_title4_item1_4"></li>
            <li [innerHtml]="termsAndConditions.terms.terms_title4_item1_5"></li>
          </ul>
        </ul>
        <h5>
            <u>{{ termsAndConditions.terms.terms_title5 }}</u>
        </h5>
        <p [innerHtml]="termsAndConditions.terms.terms_title5_item1"></p>
        <ol type="1">
            <li [innerHtml]="termsAndConditions.terms.terms_title5_item1_1"></li>
            <li [innerHtml]="termsAndConditions.terms.terms_title5_item1_2"></li>
            <li [innerHtml]="termsAndConditions.terms.terms_title5_item1_3"></li>
            <li [innerHtml]="termsAndConditions.terms.terms_title5_item1_4"></li>
            <li [innerHtml]="termsAndConditions.terms.terms_title5_item1_5"></li>
            <li [innerHtml]="termsAndConditions.terms.terms_title5_item1_6"></li>
        </ol>
        </div>
    </div>
</div>